// Get app logs from past week
export const fetchAppLogsFromPastWeek = async (appId: string) => {
  try {
    // get start date string for past week only the date part
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 7);
    const startDateString = startDate.toISOString().split('T')[0];
    const endDate = new Date();
    const endDateString = endDate.toISOString().split('T')[0];
    const logs = await fetch(
      `${process.env.REACT_APP_LOGS_URL}/api/analytics-logs/app/${appId}?startDate=${startDateString}&endDate=${endDateString}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (!logs.ok) {
      throw new Error('Failed to fetch logs');
    }

    const result = await logs.json();
    return result.data;
  } catch (error) {
    console.error('Failed to fetch logs', error);
    return null;
  }
};

export const fetchAppLogsFromPastYear = async (appId: string) => {
  try {
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 365);
    const startDateString = startDate.toISOString().split('T')[0];
    const endDate = new Date();
    const endDateString = endDate.toISOString().split('T')[0];
    // sample app id 0x486dD3B9C8DF7c9b263C75713c79EC1cf8F592F2
    const logs = await fetch(
      `${process.env.REACT_APP_LOGS_URL}/api/analytics-logs/app/${appId}?startDate=${startDateString}&endDate=${endDateString}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (!logs.ok) {
      throw new Error('Failed to fetch logs');
    }

    const result = await logs.json();
    return result.data;
  } catch (error) {
    console.error('Failed to fetch logs', error);
    return null;
  }
};

export const fetchAppLogsFromPastDay = async (appId: string) => {
  try {
    const logs = await fetch(
      `${process.env.REACT_APP_LOGS_URL}/api/analytics-logs/app/${appId}/sessions`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );

    if (!logs.ok) {
      throw new Error('Failed to fetch logs');
    }

    const result = await logs.json();
    return result.data;
  } catch (error) {
    console.error('Failed to fetch logs', error);
    return null;
  }
};

export const fetchSessionLogs = async (sessionId: string) => {
  try {
    const response = await fetch(
      `${process.env.REACT_APP_LOGS_URL}/api/analytics-logs/session/${sessionId}`
    );
    if (!response.ok) {
      throw new Error('Failed to fetch session logs');
    }

    const data = await response.json();
    // if status is 200, return data
    if (response.status === 200) {
      return data.data;
    }

    return { data: [] };
  } catch (error) {
    console.error('Error fetching session logs:', error);
    return { data: [] };
  }
};
